// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3STXK","number":"header_number__pOrbt","title":"header_title__3K53V","starButton":"header_starButton__399XM"};